// 9fbef606107a605d69c0edbcd8029e5d
import handler from '../../../handler';
import {
  defaultBrand,
  defaultChannel,
  defaultCountry,
  MobileChannel,
} from '../../../api.constants';

/**
 * Abstractor layer for loading data from API for Labels related components
 */
const Abstractor = {
  getQueryParams: (apiConfig) => {
    const { brandIdCMS, siteIdCMS, isAppChannel } = apiConfig || {};
    const isMobileChannel = isAppChannel;
    const channel = isMobileChannel ? MobileChannel : defaultChannel;
    return {
      brand: brandIdCMS || defaultBrand,
      channel,
      country: siteIdCMS || defaultCountry,
    };
  },
  getData: async (module, apiConfig) => {
    const data = Abstractor.getQueryParams(apiConfig);
    return handler
      .fetchModuleDataFromGraphQL({ name: module, data }, apiConfig)
      .then((response) => response.data)
      .then(Abstractor.processData);
  },
  processData: ({ siteConfiguration = {} }) => {
    const { crossSiteConfig = '', sameSiteConfig = '' } = siteConfiguration;
    return {
      xappConfig: sameSiteConfig && JSON.parse(sameSiteConfig),
      xappConfigOtherBrand: crossSiteConfig && JSON.parse(crossSiteConfig),
    };
  },
};
export default Abstractor;
